import { useSelector } from 'react-redux';

import { isImpersonatingUser } from 'selectors/ui/ui';

const useIsImpersonatingUser = () => {
  return useSelector(isImpersonatingUser);
};

export { useIsImpersonatingUser };
